module.exports = __webpack_public_path__ + "static/media/image_23.ed0278d9.png";